<template>
  <div>
    <div class="pagination-dropdown" v-if="pages && pages.length > 1">
      <div class="part-first">
        <el-select v-model="activePage"
          @change="currentPage" placeholder="Select">
          <el-option
            v-for="item in pages"
            :key="item.key"
            :label="item.key"
            :value="item.key">
          </el-option>
        </el-select>
      </div>
      <div class="part-second">
        <button type="button" :disabled="activePage == 'Page 1'" @click="goPrev(activePage)" class="btn-prev"><i class="el-icon el-icon-arrow-left"></i></button>
        <button type="button" :disabled="pagination.cursor.last == pagination.total" @click="goNext(activePage)" class="btn-next"><i class="el-icon el-icon-arrow-right"></i></button>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
export default {
  name: 'PaginationWidget',
  props: {
    pagination: {
      type: Object,
      required: true
    },
    isGame: false
  },
  data () {
    return {
      state: DataState.newLoading(),
      pages: [],
      activePage: null
    }
  },
  mounted () {

    let pageTotal
    if (this.isGame) {
      pageTotal = Math.ceil(this.pagination.total / 5)
    } else {
      pageTotal = Math.ceil(this.pagination.total / 10)
    }
    for (var page = 1; page <= pageTotal; page++) {
      this.pages.push({ 'key': 'Page ' + page })
      this.activePage = this.pages[0].key
    }
  },
  methods: {
    currentPage (e) {
      let pageNum = e.split(' ')
      let last
      if (this.isGame) {
        last = (pageNum[1] * 5) - 5
      } else {
        last = (pageNum[1] * 10) - 10
      }
      let cursor = {
        'last': last
      }
      this.activePage = 'Page ' + pageNum[1]
      this.$emit('loadContent', cursor)
    },
    goPrev (page) {
      let pageNum = page.split(' ')
      let activePage = (parseInt(pageNum[1]) - 1)
      this.currentPage('Page ' + activePage)
    },
    goNext (page) {
      let pageNum = page.split(' ')
      let activePage = (parseInt(pageNum[1]) + 1)
      this.currentPage('Page ' + activePage)
    }
  }
}
</script>
